import { P2GAlert } from '@parcel2go/core-ui';

interface props {
  color?: 'info' | 'warning' | 'error' | 'success';
  icon?: React.ReactNode;
  iconSrc?: string;
  loader?: React.ReactNode;
  iconSize?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
  children: React.ReactNode;
}

const AlertWithIcon: React.FC<props> = (props) => {
  return (
    <P2GAlert color={props.color || 'info'} icon={props.loader || props.icon}>
      {props.children}
    </P2GAlert>
  );
};

export default AlertWithIcon;
